import { render, staticRenderFns } from "./AccountingVatDeclarationPreview.vue?vue&type=template&id=2b33bc07&scoped=true"
import script from "./AccountingVatDeclarationPreview.vue?vue&type=script&lang=ts"
export * from "./AccountingVatDeclarationPreview.vue?vue&type=script&lang=ts"
import style0 from "./AccountingVatDeclarationPreview.vue?vue&type=style&index=0&id=2b33bc07&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b33bc07",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b33bc07')) {
      api.createRecord('2b33bc07', component.options)
    } else {
      api.reload('2b33bc07', component.options)
    }
    module.hot.accept("./AccountingVatDeclarationPreview.vue?vue&type=template&id=2b33bc07&scoped=true", function () {
      api.rerender('2b33bc07', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/bookkeeping/AccountingVatDeclarationPreview.vue"
export default component.exports